<div class="page-container max-width" [class.loading]="timeOffRequestComponent.isLoading || isLoading">
    <app-header title="{{ 'time-off-v3.editTimeOffRequest' | translate }}" [back]="true"> </app-header>
    <app-time-off-request
        [timeOffRequest]="timeOffRequest"
        #timeOffRequestComponent
        [actionType]="actionType"
        (save)="onSave($event)"
    ></app-time-off-request>
</div>
